import { useCallback, useEffect, useState } from "react";
import PrimaryHeading from "../../../components/common/primaryHeading.js";
import InputPrimaryComponents from "../../../components/common/inputPrimaryComponents.js";
import RolesCardView from "./RolesCardView.jsx";
import AddEditRoleModal from "./AddEditRoleModal.jsx";
import RolePermissionModal from "./RolePermissionModal.jsx";
import {
  useRoleActions,
  useRolesData,
  useRolePermissions,
} from "../../../hooks/rolesAndPermission";
import camp from "../../../assets/images/campIcon.svg";

export default function RoleSection({
  formProps,
  campaigns,
  style,
  fetchPermissionsTable,
  campaignValue,
  updateViewStates,
}) {
  const { control, errors, setValue } = formProps;

  const [roleModals, setRoleModals] = useState({
    addNew: false,
    edit: null,
    permission: null,
  });

  const { addNew, edit: editRole, permission: editRolePermission } = roleModals;

  const updateRoleModals = useCallback((updates) => {
    setRoleModals((prev) => ({ ...prev, ...updates }));
  }, []);

  const {
    fetchRolesByCamp,
    roleDetails,
  } = useRolesData();
  const rolePermissions = useRolePermissions();

  useEffect(() => {
    if (campaignValue) {
      fetchRolesByCamp(campaignValue);
    }
  }, [campaignValue, fetchRolesByCamp]);

  const { handleRoleAction, handleAddPermissions } = useRoleActions({
    rolePermissions,
    fetchRolesByCamp,
    fetchPermissionsTable,
    campaignValue,
    setAddNewRole: (value) => updateRoleModals({ addNew: value }),
    setEditRole: (value) => updateRoleModals({ edit: value }),
    setEditRolePermission: (value) => updateRoleModals({ permission: value }),
  });

  const handleRoleCardClick = useCallback(
    async (item, purpose) => {
      if (purpose === "permission") {
        updateRoleModals({ permission: item });
        // fetchAssignedPermissions will automatically fetch permissionsList if needed
        rolePermissions.fetchAssignedPermissions(item?.app_role_id);
      } else if (purpose === "cardDetails") {
        updateViewStates({ showRoleUserView: true, selectedRole: item });
      } else {
        updateRoleModals({ edit: item });
        setValue("role_name", item?.role_name);
      }
    },
    [
      setValue,
      rolePermissions,
      updateRoleModals,
      updateViewStates,
    ]
  );

  return (
    <>
      <div className={style?.cardContainers}>
        <div className={style?.titleRow}>
          <PrimaryHeading className={style?.heading} children={"Roles"} />
          <div className="Camp_dropdown ">
            <InputPrimaryComponents
              key="campaign-dropdown"
              inputParentClass={"div_pb-0"}
              type={"dropdown"}
              control={control}
              errors={errors}
              name={"campaign"}
              rules={{ required: "Select campaign" }}
              options={campaigns}
              onChange={fetchRolesByCamp}
              valueTemplate={(value) => (
                <div className="flex align-items-center gap-2">
                  {typeof value?.icon === "string" ? (
                    <i className={value?.icon}></i>
                  ) : value?.icon ? (
                    value?.icon
                  ) : (
                    <img
                      src={camp}
                      alt="campaign"
                      style={{ width: "16px", height: "16px" }}
                    />
                  )}
                  <span className="md:flex hidden">{value?.label}</span>
                </div>
              )}
            />
          </div>
        </div>
        <RolesCardView
          headerClass={style?.cardNestedContainers}
          data={roleDetails}
          setAddNewRole={(value) => updateRoleModals({ addNew: value })}
          onClick={handleRoleCardClick}
        />
      </div>

      <AddEditRoleModal
        visible={addNew || !!editRole}
        onHide={() => {
          updateRoleModals({ addNew: false, edit: null });
        }}
        onSubmit={(data) => handleRoleAction(data, editRole)}
        editRole={editRole}
        loading={rolePermissions.loading}
      />

      <RolePermissionModal
        visible={!!editRolePermission}
        onHide={() => {
          updateRoleModals({ permission: null });
          rolePermissions.setAssignedPermissions([]);
          rolePermissions.setAvailablePermissions(rolePermissions.permissionsList);
        }}
        onSubmit={() => handleAddPermissions(editRolePermission)}
        onCancel={() => {
          updateRoleModals({ permission: null });
          rolePermissions.setAssignedPermissions([]);
          rolePermissions.setAvailablePermissions(rolePermissions.permissionsList);
        }}
        editRolePermission={editRolePermission}
        permissionsList={rolePermissions.permissionsList}
        
        assignedPermissions={rolePermissions.assignedPermissions}
        setAssignedPermissions={rolePermissions.setAssignedPermissions}
        
        availablePermissions={rolePermissions.availablePermissions}
        setAvailablePermissions={rolePermissions.setAvailablePermissions}
        loading={rolePermissions.loading}
      />
    </>
  );
}
